const tiposJustificantes = {
  registroCheck: 'RegistroCheck',
  asistencia: 'Asistencia',
}

export default tiposJustificantes;
